import type { E164Number, PhoneNumber } from 'libphonenumber-js/max/es6';
import { ParseError, parsePhoneNumberWithError } from 'libphonenumber-js/max/es6';

export function isValidPhoneNumber(e164: string): boolean {
  try {
    const parsed = parsePhoneNumber(e164);
    return parsed.isValid();
  } catch (error) {
    if (error instanceof ParseError) {
      return false;
    }
    throw error;
  }
}

export function parsePhoneNumber(e164: E164Number): PhoneNumber {
  return parsePhoneNumberWithError(e164, { extract: false });
}

export function telUrl(e164: E164Number) {
  return `tel:+${e164}`;
}

export function whatsappUrl(e164: E164Number) {
  return `https://wa.me/${e164}`;
}
